var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSharePoll(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.53353 18.1791C12.479 18.1791 14.8669 15.7913 14.8669 12.8458C14.8669 9.90027 12.479 7.51245 9.53353 7.51245C6.58801 7.51245 4.2002 9.90027 4.2002 12.8458C4.2002 15.7913 6.58801 18.1791 9.53353 18.1791Z",
    stroke: "#42296E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 24.5792C1.94667 20.8992 5.55733 18.1792 9.53333 18.1792C13.5093 18.1792 17.12 20.8992 18.0667 24.5792",
    stroke: "#42296E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.2002 16.7125C21.3784 16.7125 22.3336 15.7573 22.3336 14.5791C22.3336 13.4009 21.3784 12.4458 20.2002 12.4458C19.022 12.4458 18.0669 13.4009 18.0669 14.5791C18.0669 15.7573 19.022 16.7125 20.2002 16.7125Z",
    stroke: "#42296E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6665 21.5125C28.8447 21.5125 29.7999 20.5574 29.7999 19.3792C29.7999 18.201 28.8447 17.2458 27.6665 17.2458C26.4883 17.2458 25.5332 18.201 25.5332 19.3792C25.5332 20.5574 26.4883 21.5125 27.6665 21.5125Z",
    stroke: "#42296E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6665 11.9124C28.8447 11.9124 29.7999 10.9573 29.7999 9.77909C29.7999 8.60088 28.8447 7.64575 27.6665 7.64575C26.4883 7.64575 25.5332 8.60088 25.5332 9.77909C25.5332 10.9573 26.4883 11.9124 27.6665 11.9124Z",
    stroke: "#42296E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8723 10.9326L21.9937 13.4259",
    stroke: "#42296E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9937 15.7327L25.8723 18.226",
    stroke: "#42296E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharePoll);
export default __webpack_public_path__ + "static/media/share-poll.a9bc56a2f5fed0d7c2a63e4194e9dba3.svg";
export { ForwardRef as ReactComponent };